import { css } from 'styled-jsx/css';

export default css`
  .hidden {
    display: none !important;
  }

  .sub-group-list-title {
    font-weight: bold;
    letter-spacing: 0;
    margin: 12px 0;
  }

  .sub-group-list-description {
    color: #949494;
    font-family: 'Roboto-Medium';
    font-size: 16px;
    letter-spacing: 0;
    margin-bottom: 24px;
  }

  .sub-group-lists-options {
    display: flex;
    flex-direction: column;
  }

  .sub-group-list-options {
    margin-bottom: 1rem;
  }

  .compared_at_price_diff {
    color: #949494;
    text-decoration: line-through;
    margin-left: 5px;
  }

  .green {
    margin-left: 5px;
    color: #7ed321;
  }

  .red {
    margin-left: 5px;
    color: #950810;
  }

  .disabled_text {
    color: #e4e4e4;
    opacity: 0.6;
  }

  .error_group {
    border: 1px solid #fd0300;
  }

  .error_icon {
    position: absolute;
    right: -10px;
    top: -10px;
  }

  input[type='radio'] {
    cursor: pointer;
    margin-right: 10px;
    float: left;
  }

  input[type='radio']:after {
    cursor: pointer;
    width: 12px;
    height: 12px;
    border-radius: 12px;
    position: relative;
    background-color: white;
    content: '';
    display: inline-block;
    visibility: visible;
    border: 2px solid white;
  }
  input[type='radio']:disabled:after {
    background-color: #949494;
  }

  input[type='radio']:checked:after {
    cursor: pointer;
    width: 12px;
    height: 12px;
    border-radius: 12px;
    position: relative;
    background-color: #fd0300;
    content: '';
    display: inline-block;
    visibility: visible;
    border: 2px solid white;
  }
  .label-container {
    padding-left: 10px;
  }
  label {
    display: block;
    margin-left: 30px;
  }
`;
